module.exports = __webpack_public_path__ + "img/49.6fef0bc2.svg";